import axios from 'axios';
import moment from 'moment';
import { all, put, takeLatest } from 'redux-saga/effects';

import { STATISTICS } from 'app/api-routes';
import { ALL, DATE_TIME_FORMAT } from 'app/types/constants';
import {
  biShiftsByEmployeeFailure,
  biShiftsByEmployeeRequest,
  biShiftsByEmployeeSuccess,
  biShiftsByMobilePatrolFailure,
  biShiftsByMobilePatrolRequest,
  biShiftsByMobilePatrolSuccess,
  biShiftsBySiteFailure,
  biShiftsBySiteRequest,
  biShiftsBySiteSuccess,
  biShiftsDetailedFailure,
  biShiftsDetailedRequest,
  biShiftsDetailedSuccess,
  setLoadingState,
} from './actions';


function* biShiftsBySiteSaga({ payload: { month, year, siteID, clientID, supervisorID, userID, statuses } }) {
  const startDate = moment(`${year}-${month}`).startOf('month').format(DATE_TIME_FORMAT);
  const endDate = moment(`${year}-${month}`).endOf('month').format(DATE_TIME_FORMAT);

  const params = {
    startDate,
    endDate,
    timeZoneOffset: moment().utcOffset(),
  };

  if (siteID) {
    params.siteID = siteID;
  }

  if (clientID) {
    params.clientID = clientID;
  }

  if (supervisorID) {
    params.supervisorID = supervisorID;
  }

  if (userID) {
    params.userID = userID;
  }

  if (statuses && statuses.length && !statuses.includes(ALL)) {
    params.statuses = statuses;
  }

  try {
    yield put(setLoadingState(true));
    const { payload, warnings } = yield axios.get(`${STATISTICS}/shifts/grouped-by-site`, {
      params,
    });
    yield put(biShiftsBySiteSuccess(payload, { warnings }));
  } catch (err) {
    yield put(biShiftsBySiteFailure(err));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* biShiftsByEmployeeSaga({
  payload: { month, year, siteID, userID, statuses },
}) {
  const startDate = moment(`${year}-${month}`).startOf('month').format(DATE_TIME_FORMAT);
  const endDate = moment(`${year}-${month}`).endOf('month').format(DATE_TIME_FORMAT);

  const params = {
    startDate,
    endDate,
    timeZoneOffset: moment().utcOffset(),
  };

  if (siteID) {
    params.siteID = siteID;
  }

  if (userID) {
    params.userID = userID;
  }

  if (statuses && statuses.length && !statuses.includes(ALL)) {
    params.statuses = statuses;
  }

  try {
    const { payload, warnings } = yield axios.get(`${STATISTICS}/shifts/grouped-by-employee`, {
      params,
    });
    yield put(biShiftsByEmployeeSuccess(payload, { warnings }));
  } catch (err) {
    yield put(biShiftsByEmployeeFailure(err));
  }
}

function* biShiftsByMobilePatrolSaga({
  payload: { month, year, mobilePatrolID, statuses },
}) {
  const startDate = moment(`${year}-${month}`).startOf('month').format(DATE_TIME_FORMAT);
  const endDate = moment(`${year}-${month}`).endOf('month').format(DATE_TIME_FORMAT);

  const params = {
    startDate,
    endDate,
    timeZoneOffset: moment().utcOffset(),
  };

  if (mobilePatrolID) {
    params.mobilePatrolID = mobilePatrolID;
  }

  if (statuses && statuses.length && !statuses.includes(ALL)) {
    params.statuses = statuses;
  }

  try {
    const { payload, warnings } = yield axios.get(
      `${STATISTICS}/shifts/grouped-by-mobile-patrol`,
      {
        params,
      }
    );
    yield put(biShiftsByMobilePatrolSuccess(payload, { warnings }));
  } catch (err) {
    yield put(biShiftsByMobilePatrolFailure(err));
  }
}

function* biShiftsDetailedSaga({
  payload: { month, year, siteID, clientID, supervisorID, mobilePatrolID, statuses },
}) {
  const startDate = moment(`${year}-${month}`).startOf('month').format(DATE_TIME_FORMAT);
  const endDate = moment(`${year}-${month}`).endOf('month').format(DATE_TIME_FORMAT);

  const params = {
    startDate,
    endDate,
    timeZoneOffset: moment().utcOffset(),
  };

  if (siteID) {
    params.siteID = siteID;
  }

  if (clientID) {
    params.clientID = clientID;
  }

  if (supervisorID) {
    params.supervisorID = supervisorID;
  }

  if (mobilePatrolID) {
    params.mobilePatrolID = mobilePatrolID;
  }

  if (statuses && statuses.length && !statuses.includes(ALL)) {
    params.statuses = statuses;
  }

  try {
    const { payload, warnings } = yield axios.get(
      `${STATISTICS}/shifts/bi-shifts-detailed`,
      {
        params,
      }
    );
    yield put(biShiftsDetailedSuccess(payload, { warnings }));
  } catch (err) {
    yield put(biShiftsDetailedFailure(err));
  }
}

export default function* () {
  yield all([
    takeLatest(biShiftsBySiteRequest, biShiftsBySiteSaga),
    takeLatest(biShiftsByEmployeeRequest, biShiftsByEmployeeSaga),
    takeLatest(biShiftsByMobilePatrolRequest, biShiftsByMobilePatrolSaga),
    takeLatest(biShiftsDetailedRequest, biShiftsDetailedSaga),
  ]);
}
